var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFastForward = function SvgFastForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "fast-forward_svg__Layer_1",
    width: 24,
    height: 24,
    strokeWidth: 1.5,
    color: "#24053b",
    "data-name": "Layer 1",
    role: "presentation"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-6374f543b67f094e4896c5d0-1{fill:none;stroke:currentColor;stroke-miterlimit:10}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10.5,
    className: "cls-6374f543b67f094e4896c5d0-1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.04 12-4.77 2.86V9.14zM16.77 12 12 14.86V9.14zM17.73 7.23v9.54",
    className: "cls-6374f543b67f094e4896c5d0-1"
  })));
};
export default SvgFastForward;